module.exports = __webpack_public_path__ + "img/workNewsCover1.f7ab96eb.png";